import { atom } from 'jotai';

export const projectIdAtom = atom<string>('');
